import React, { Component } from 'react'
import "./freecross_custom_chart.scss"
import { getCustomBarOption } from "../../../util/Chart_config/Custom_chart_config";
import FreecrossMaxChartPopup from '../Freecross_max_chart_popup/freecross_max_chart_popup'
import { formatChart } from "../../../util/Chart_config/Config";
import * as echarts from 'echarts';
import { Tooltip } from 'antd';


export default class freecross_custom_chart extends Component {
    constructor(props) {
        super(props);
        this.maxChartRef = React.createRef();
        this.state = {
            dataList: {},
            question_id: "",
            needRefresh: false,
            isMaxSreen: false,
            showMaxChartPopup: false, // 是否显示放大图表的对话框
        };
    }
    componentDidMount() {
        this._isMounted = true
        if (this._isMounted) {
            this.toInitChart()
            setTimeout(() => {
                this.toInitFoot()
            })
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
        this.setState = () => { }
    }
    componentDidUpdate() {
        if (this._isMounted && this.state.needRefresh) {
            this.toInitChart()
            setTimeout(() => {
                this.toInitFoot()
            })
            this.setState({
                needRefresh: false
            })
        }
    }
    static getDerivedStateFromProps(props, state) {
        if (JSON.stringify(props.dataList) !== JSON.stringify(state.dataList_prev)) {
            return {
                needRefresh: true,
                dataList: props.dataList,
                dataList_prev: props.dataList
            }
        }
        return null;

    }
    toInitChart() {
        let id = "chart_" + this.props.single_id
        if (this.state.showMaxChartPopup) {
            id = "max_" + id
        }
        let xAxisList = this.props.dataList.x_axis
        let data = this.props.dataList.data

        let sum = data.reduce(function (prev, curr) {
            return prev + curr;
        }, 0);

        let option = getCustomBarOption(xAxisList, data, sum)

        formatChart(id, option)
        if (this.state.showMaxChartPopup) {
            setTimeout(() => {
                this.toInitFootMax()
            }, 10)
        }
    }
    toInitFootMax() {
        let id = "max_chart_" + this.props.single_id
        let canvas = document.getElementById(id)
        if (!canvas) return
        let canvas_width = window.getComputedStyle(canvas).width;
        let canvas_width_val = parseInt(canvas_width.slice(0, canvas_width.length - 2))
        let canvas_height = window.getComputedStyle(canvas).height;
        let canvas_height_val = parseInt(canvas_height.slice(0, canvas_height.length - 2))

        let card_chart_rect = canvas.getBoundingClientRect();
        let card_chart_rect_top = card_chart_rect.top
        let card_chart_rect_left = card_chart_rect.left
        let foot = document.querySelector(`.max-custom-chart-foot`);
        foot.style.top = 0
        foot.style.left = parseInt(card_chart_rect_left + 48) + "px"
        foot.style.marginTop = parseInt(canvas_height_val + card_chart_rect_top - 45) + "px"
        foot.style.width = parseInt(canvas_width_val - 58) + "px"

        let count_arr = this.props.dataList.word_bar_count_arr
        let sum = count_arr.reduce(function (prev, curr) {
            return prev + curr;
        }, 0);

        // 设置三个下标的距离
        let count_width_arr = []
        count_arr.forEach((item, index) => {
            let foot_div = document.querySelector(`.max-foot-name-${index}`);
            let tmp_width = parseInt(item) / sum * 100
            count_width_arr[index] = tmp_width
            if (index === 0) {
                foot_div.style.cssText = `width: ${tmp_width}%;`
            } else if (index === 1) {
                foot_div.style.cssText = `width: ${tmp_width}%`
            } else if (index === 2) {
                foot_div.style.cssText = `width: ${tmp_width}%;right: 0;`
                let foot_div_1 = document.querySelector(`.max-foot-name-1`);
                foot_div_1.style.cssText = `width: ${count_width_arr[1]}%;right:${tmp_width}%;`
            }
        })
    }
    // 生产三个title的下标
    toInitFoot() {
        let single_id = this.props.single_id
        let canvas = document.querySelector(`.custom_${single_id}`);
        if (!canvas) return
        let canvas_height = window.getComputedStyle(canvas).height;
        let canvas_height_val = parseInt(canvas_height.slice(0, canvas_height.length - 2))

        let foot = document.querySelector(`.custom-chart-foot`);
        foot.style.top = 0
        foot.style.marginTop = canvas_height_val - 45 + "px"

        let count_arr = this.props.dataList.word_bar_count_arr
        let sum = count_arr.reduce(function (prev, curr) {
            return prev + curr;
        }, 0);

        // 设置三个下标的距离
        let count_width_arr = []
        count_arr.forEach((item, index) => {
            let foot_div = document.querySelector(`.foot-name-${index}`);
            let tmp_width = parseInt(item) / sum * 100
            count_width_arr[index] = tmp_width
            if (index === 0) {
                foot_div.style.cssText = `width: ${tmp_width}%;`
            } else if (index === 1) {
                foot_div.style.cssText = `width: ${tmp_width}%`
            } else if (index === 2) {
                foot_div.style.cssText = `width: ${tmp_width}%;right: 0;`
                let foot_div_1 = document.querySelector(`.foot-name-1`);
                foot_div_1.style.cssText = `width: ${count_width_arr[1]}%;right:${tmp_width}%;`
            }
        })
    }
    // 放大图表
    handleMaxCustomChart() {
        this.maxChartRef.current.setMaxChart({
            dataList: this.props.dataList,
            single_id: this.props.single_id,
            isConsumer: false
        })
        this.setState({
            showMaxChartPopup: true,
        })
    }
    // 子组件传给父组件状态 是否放大图表
    canShowMaxChartPopup(object) {
        this.setState({
            showMaxChartPopup: object.showMaxChartPopup,
        })
    }
    render() {
        let single_id = String(this.props.single_id) || ""
        let name = this.props.dataList.name || ""
        return (
            <div className='pannel-card freecross-pannel-card-custom'>
                <div className='chart-operaion-wrapper'>
                    <div className="chart-operaion-text" onClick={this.handleMaxCustomChart.bind(this)}>放大</div>
                </div>
                <div className="custom-chart-father" id={`chart_${single_id}_wrapper`}>
                    <div id={`chart_${single_id}`} className={`echart-container custom-echart custom_${single_id}`}></div>
                    <div className="custom-chart-foot">
                        <div className="foot-name foot-name-0">
                            <div className="line"></div>
                            <div className="sign"></div>
                            <div className="content">贬损者</div>
                        </div>
                        <div className="foot-name foot-name-1">
                            <div className="line"></div>
                            <div className="sign"></div>
                            <div className="content">被动者</div>
                        </div>
                        <div className="foot-name foot-name-2">
                            <div className="line"></div>
                            <div className="sign"></div>
                            <div className="content">推荐者</div>
                        </div>
                    </div>
                    <div className={this.state.showMaxChartPopup ? 'chart-wrapper-2' : 'isHide'}>
                        <FreecrossMaxChartPopup ref={this.maxChartRef}
                            canShowMaxChartPopup={this.canShowMaxChartPopup.bind(this)}
                            toInitChart={this.toInitChart.bind(this)}
                        ></FreecrossMaxChartPopup>
                    </div>
                </div>
            </div >
        )
    }
}
